module.exports = __webpack_public_path__ + "img/wheelplanting.573168ad.jpg";